import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import Routes from "./views/routes";
import * as serviceWorker from "./serviceWorker";
import intl from "react-intl-universal";
import sw from "i18n/sw.js";
import fr from "i18n/fr.js";
import en from "i18n/en.js";
import bn from "i18n/bn.js";
import hi from "i18n/hi.js";


let lang =
  (navigator.languages && navigator.languages[0]) || navigator.language;
let langUse: string;
if (lang.split("-")[0].toLowerCase() === "sw") {
  // document.body.style.direction = "rtl";//整体反向
  // 斯瓦希里
  langUse = "sw";
} else if (lang.split("-")[0].toLowerCase() === "fr") {
  // 法语
  langUse = "fr";
} else if (lang.split("-")[0].toLowerCase() === "hi") {
  // 印地语
  langUse = "hi";
} else if (lang.split("-")[0].toLowerCase() === "bn") {
  // 孟加拉语
  langUse = "bn";
} else {
  // 英语
  langUse = "en";
}
// langUse = "fr";
JsBridge.callMethod("getAppInfo",123,{},
  function (msg: any) {
    if (msg.code === "0" || msg.code === 0) {
      if (msg.data.mcc&&+msg.data.mcc===410) {
        // 巴基斯坦 mcc410 使用英语
        langUse='en';
      }
    }
  }
)

intl.init({
  currentLocale: langUse,
  locales: {
    sw,
    fr,
    hi,
    bn,
    en,
  }
});

ReactDOM.render(<Routes />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
